import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const requiredAuth = to.matched.some(record => record.meta.requiredAuth);

  const currentUser = localStorage.getItem("token");

  if (requiredAuth && !currentUser) {
    next("/login");
  } else if (requiredAuth && currentUser) {
    next();
  } else {
    next();
  }

  const loginPath = to.path;

  if (loginPath === "/login" && currentUser) {
    next("/datapoints");
  }
});

export default router;
